function stringify(params: EmoneyQueryParams): string {
  return new URLSearchParams(params).toString();
}

export type EmoneyQueryParams = {
  redirect: string;
} & Record<string, string>;

export const getEmoneyIntegrationLoginPath = (
  queryParams: EmoneyQueryParams
): string => `/api/v1/emoney/auth/initiate?${stringify(queryParams)}`;

export const getEmoneyIntegrationLogoutPath = (
  queryParams: EmoneyQueryParams
): string => `/api/v1/emoney/auth/logout?${stringify(queryParams)}`;
